import axios from "./axios-handler.service";
import { Paginacao } from "@/shared/interface";
const BASE_URL = "/api/canallead";

export interface CanalLead {
  idCanalLead: number;
  nome: string;
}

export interface CanalLeadCommand {
  nome: string;
}

export interface Filtro {
  term: string;
  offset: number;
  limit: number;
  order?: string;
}

export class CanalLeadService {
  static async obter(id: number): Promise<CanalLead> {
    const response = await axios.get<CanalLead>(`${BASE_URL}/obter/${id}`);
    return response.data;
  }
  static async obterCanalLead(): Promise<CanalLead[]> {
    const response = await axios.get<CanalLead[]>(
      `${BASE_URL}/ObterCanalLeads`
    );
    return response.data;
  }

  static async cadastrarCanalLead(
    command: CanalLeadCommand
  ): Promise<CanalLead> {
    const response = await axios.post<CanalLead>(
      `${BASE_URL}/CadastrarCanalLead`,
      command
    );
    return response.data;
  }

  static async alterarCanalLead(
    idCanalLead: number,
    command: CanalLeadCommand
  ): Promise<CanalLead> {
    const response = await axios.put<CanalLead>(
      `${BASE_URL}/alterarCanalLead/${idCanalLead}`,
      command
    );
    return response.data;
  }

  static async listarCanaisLead(filtro: Filtro): Promise<Paginacao<CanalLead>> {
    const { term, offset, limit, order } = filtro;
    const response = await axios.get<Paginacao<CanalLead>>(
      `${BASE_URL}/ListarCanaisLead`,
      {
        params: {
          txtPesquisa: term,
          offset,
          limit,
          order,
        },
      }
    );
    return response.data;
  }

  static async excluirCanalLead(idCanalLead: number): Promise<boolean> {
    const response = await axios.delete<boolean>(
      `${BASE_URL}/excluirCanalLead/${idCanalLead}`
    );
    return response.data;
  }
}
